import { Filter } from "bad-words";

export const PUBLIC_MEMBER_NAME = "Meex member";
export const MAX_PROFILE_NAME_LENGTH = 35;

const nameFilter = new Filter({ exclude: ["dick"] });

export const isProfaneName = (name) =>
  typeof name === "string" && nameFilter.isProfane(name);

export const cleanName = (name) => {
  if (!name) return "";

  const cleaned = name
    .replace(/^(Dr\.?|Prof\.?|MBA|PhD|Mr\.?|Ms\.?|Mrs\.?)\s*/i, "")
    // Strip everything from the first ". CREDENTIAL" separator onwards
    // e.g. "Hoda Mohammad Pour. M.A.Sc , EIT" → "Hoda Mohammad Pour"
    .replace(/\s*\.\s+.*$/, "")
    .replace(
      /\s+(CPA|CBV|CFA|CFP|CMA|CFE|PMP|PEng|P\.?Eng|CSCP|CHRP|CHRL|FCPA|FCGA|FCMA|FCA|CA|CGA|CMA|LLB|LLM|JD|MD|RN|BBA|BComm?|M\.?A\.?Sc\.?|B\.?A\.?Sc\.?|M\.?Eng\.?|B\.?Eng\.?|MSc|BSc|BA|MA|EMBA|DBA|Esq\.?|PE|RA|AIA|LEED|RIBO|CLU|FCIA|FSA|FASSA|ASA|MAAA|ARM|CCSP|CISSP|CISA|CISM|PHR|SPHR|SHRM|RPA|ACCA|FRM|EIT|OLS|BCLS|AIAA|MRICS|FRICS)(?:\\s+.*)?$/i,
      "",
    )
    .replace(/\s*(Dr\.?|Prof\.?|MBA|PhD|,\s*PhD|Jr\.?|Sr\.?|II|III)$/i, "")
    // Keep surnames after nicknames, e.g. "Subrata (Subu) Biswas".
    .replace(/\s*\([^)]*\)\s*/g, " ")
    // Credentials and metadata are typically comma or spaced-dash suffixes.
    .split(/[,/]/)[0]
    .replace(/\s[-–—]\s.*$/, "")
    .trim()
    .replace(/[^\p{L}\s'-]/gu, "")
    .replace(/\s+/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => {
      return word
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("-");
    })
    .join(" ");

  return cleaned;
};

export const getSafePublicDisplayName = (
  givenName,
  familyName = "",
  fallbackName = "",
) => {
  const structuredParts = [givenName, familyName]
    .filter((part) => typeof part === "string")
    .map((part) => part.trim())
    .filter(Boolean);
  const hasStructuredName = structuredParts.length > 0;
  const candidate = hasStructuredName
    ? structuredParts.join(" ")
    : typeof fallbackName === "string"
      ? fallbackName
      : "";
  const displayName = cleanDisplayName(candidate);
  const isOverlong = hasStructuredName
    ? structuredParts.some(
        (part) => [...cleanDisplayName(part)].length > MAX_PROFILE_NAME_LENGTH,
      )
    : [...displayName].length > MAX_PROFILE_NAME_LENGTH;

  if (
    !displayName ||
    isOverlong ||
    isProfaneName(displayName)
  ) {
    return PUBLIC_MEMBER_NAME;
  }

  return displayName;
};

export const getSafePublicReviewerName = (givenName, familyName = "") => {
  const safeGivenName = getSafePublicDisplayName(givenName);
  if (safeGivenName === PUBLIC_MEMBER_NAME) return safeGivenName;

  const safeFamilyName = getSafePublicDisplayName("", familyName);
  if (safeFamilyName === PUBLIC_MEMBER_NAME) return safeGivenName;

  return `${safeGivenName} ${Array.from(safeFamilyName)[0]}.`;
};

export const cleanProfessionalDisplayText = (value) =>
  (value || "")
    .replace(/\s*\([^)]*\)/g, "")
    .replace(/[\p{Extended_Pictographic}\uFE0F\u200D]/gu, "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/\s+@\s+.*$/u, "")
    .replace(/(?:[|,/:;]|\s[-–—]\s|[–—]).*$/u, "")
    .replace(/\s+/g, " ")
    .trim();

export const cleanDisplayName = (value) =>
  (value || "")
    .replace(/\s*\([^)]*\)\s*/g, " ")
    .replace(/[\p{Extended_Pictographic}\uFE0F\u200D]/gu, "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const cleanLinkedInText = (value) =>
  (value || "")
    // Remove emoji and emoji presentation markers while keeping words/punctuation.
    .replace(/[\p{Extended_Pictographic}\uFE0F\u200D]/gu, "")
    // Remove control chars (except tabs/new lines, then normalize below).
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "")
    .replace(/\s+/g, " ")
    .trim();
